import UrlGeneration from '@lovata/url-generation';

export default new class TagBlogPagination {
  constructor() {
    this.sPaginationLink = '_blog-tag-pagination';
    this.postListWrapper = '_blog-tag-post-list__wrapper';
    this.paginationWrapper = '_blog-tag-post-pagination__wrapper';

    this.initPagination();
  }

  initPagination() {
    $(document).on('click', `.${this.sPaginationLink}`, (obEvent) => {
      obEvent.preventDefault();
      obEvent.stopPropagation();
      const obButton = $(obEvent.currentTarget);
      const iPage = obButton.attr('data-page');

      UrlGeneration.init();
      if (iPage === '1') {
        UrlGeneration.remove('page');
      } else {
        UrlGeneration.set('page', [iPage]);
      }
      UrlGeneration.update();

      $.request('onAjax', {
        update: {
          'blog/tag-post-list/tag-post-list-ajax': `.${this.postListWrapper}`,
          'blog/tag-post-list/tag-post-list-pagination-ajax': `.${this.paginationWrapper}`,
        },
        complete: () => {
          const bar = $(`.${this.postListWrapper}`);
          if (!bar.length) return;
          const distance = bar.offset().top;
          $('body, html')
            .animate({ scrollTop: distance }, 350);
        },
      });
    });
  }
}();
